import {html} from "lit-element";
import "@stofloos/components/organisms/tables/table-dynamic";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "@stofloos/components/molecules/dialogs/dialog-simple";
import "@stofloos/components/molecules/forms/sw-form";
import "@stofloos/components/atoms/inputs/input-checkbox";
import "@stofloos/components/atoms/buttons/button-contained";
import "@stofloos/components/atoms/buttons/button-outlined";
import "@stofloos/components/atoms/buttons/button-text";
import "@stofloos/components/atoms/loaders/sw-fullscreen-spinner";

import {style} from "./style";
import {StofwareCrudSingle} from "@stofloos/core/base/sw-crud-single";
import {formToJSON, getFormElements, textToSlug, validateForm} from "@stofloos/utils/sw-constants";

import {localize} from "@stofloos/actions/localize";
import {ButtonContainedStyle} from "@stofloos/components/atoms/buttons/button-contained/src";


class PageOrder extends StofwareCrudSingle{

    static get properties() {
        return {
            label: String,
            active: {type: Boolean},
            config: Array
        }
    }

    constructor() {
        super();
    }

    static get styles() {
        return [
            LayoutFlex,
            ButtonContainedStyle,
            style
        ]
    }

    updated(changedProperties) {
        if(this.active && changedProperties.has('id') && this.id !== "undefined" && this.object !== "undefined") {
            this.readObject();
        }
    }

    render() {
        if(this.object && this.object.status === 'paid') {
            sessionStorage.removeItem('event_'+this.object.id);
        }
        return html`

            <sw-fullscreen-spinner ?active="${this.isLoading}"></sw-fullscreen-spinner>
            ${!this.isLoading && this.object ? html`
                <div class="page-container layout vertical center">
                    <div class="banner-container">
                        <slot></slot>
                        <div class="banner layout vertical center-center">
                             <h1>${localize(this.label)}</h1>
                        </div>
                    </div>
                    
                    <div class="section first layout vertical center-center shadow">
                        ${this.object.status === 'paid' ? html`
                            <h1>Uw bestelling is gelukt!</h1>
                                   
                            <div class="layout horizontal">
                                <div class="layout vertical flex">
                                    <p>Hartelijk dank voor uw aanmelding. Controleer uw mail voor de bevestiging.</p>
                                    <p>Mocht u geen mail hebben ontvangen, dan is het mogelijk dat deze in uw ongewenste mail is gekomen.</p>
                                    <div class="layout vertical center-center button-contained">
                                        <a href="/home">Bekijk meer congressen</a>
                                    </div>
                                </div>
                            </div>
                        ` : ``}
                        
                        ${this.object.status === 'cancelled' ? html`
                            <h1>Bestelling mislukt</h1>
                                   
                            <div class="layout horizontal">
                                <div class="layout vertical flex">
                                    <p>De betaling is niet gelukt. U kunt de aanmelding opnieuw plaatsen.</p>
                                
                                    <div class="layout vertical center-center button-contained">
                                        <a href="/congres/${textToSlug(this.object.title)}/${this.object.id}">Opnieuw proberen</a>
                                    </div>
                                </div>
                            </div>
                        ` : ``}
                                           
                    </div>
                   
                    
                   
                </div>
            ` : ``}
            
            
            
        `;
    }
}


window.customElements.define("page-order", PageOrder);
